import { RequestManagement } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// RequestManagementServices contains functions to interact with instructor management-related APIs.
// Each function corresponds to a specific API endpoint for tasks such as fetching users, updating instructor status, etc.
export const RequestManagementServices = {
  /**
   * Function for fetching instructor data based on query parameters.
   * @param {Object} queryParams - Query parameters for fetching users.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get users API.
   */
  getInstructorRequestService: async ({ queryParams }) => {
    try {
      const payload = {
        ...RequestManagement.getRequestData,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  sendRequest: async (bodyData) => {
    try {
      const payload = {
        ...RequestManagement.sendRequest,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
